import { BaseApiClient } from './base'
import type { ReferralLink, ReferralStats, ReferralGoal, BonusDownloadsSummary } from '../../types'

export class ReferralsApi extends BaseApiClient {
  /**
   * Get user's referral link.
   * Generates a referral code if user doesn't have one yet.
   */
  async getReferralLink(baseUrl?: string): Promise<ReferralLink> {
    const params = baseUrl ? `?base_url=${encodeURIComponent(baseUrl)}` : ''
    return this.request(`/referrals/link${params}`)
  }

  /**
   * Get comprehensive referral statistics.
   */
  async getReferralStats(): Promise<ReferralStats> {
    return this.request('/referrals/stats')
  }

  /**
   * Get all goals with user's progress.
   */
  async getGoalsProgress(): Promise<{ goals: ReferralGoal[] }> {
    return this.request('/referrals/goals')
  }

  /**
   * Claim a completed goal reward.
   */
  async claimGoalReward(goalId: number): Promise<{
    success: boolean
    message: string
    reward_type?: string
    reward_amount?: number
    new_balance?: number
  }> {
    return this.request(`/referrals/goals/${goalId}/claim`, { method: 'POST' })
  }

  /**
   * Get user's bonus downloads summary.
   */
  async getBonusDownloads(): Promise<BonusDownloadsSummary> {
    return this.request('/referrals/bonus-downloads')
  }
}

